import { SelectionModel } from '@angular/cdk/collections'
import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDialog } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { DirectivesModule, PatientUploadedFile } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { PatientFileViewComponent } from '../../../patient-file-view'

@Component({
  selector: 'mmx-auth-attachments-table',
  templateUrl: './auth-attachments-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatCheckboxModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    DirectivesModule,
    TranslateModule,
  ],
})
export class AuthAttachmentsTableComponent implements OnChanges {
  @Input()
  public attachments: PatientUploadedFile[]

  @Output()
  public delete = new EventEmitter<PatientUploadedFile[]>()

  public displayedColumns = ['select', 'fileName', 'dateUploaded', 'actions']
  public dataSource = new MatTableDataSource<PatientUploadedFile>()
  public selection = new SelectionModel<PatientUploadedFile>(true, [])

  constructor(
    private dialog: MatDialog,
  ) { }

  public ngOnChanges() {
    this.dataSource.data = this.attachments
  }

  public isAllSelected() {
    const numSelected = this.selection.selected.length
    const numRows = this.dataSource.data.length
    return numSelected === numRows
  }

  public toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear()
      return
    }

    this.selection.select(...this.dataSource.data)
  }

  public viewFile({ event, file }: { event: MouseEvent, file: PatientUploadedFile }) {
    event.stopPropagation()
    event.preventDefault()

    this.dialog.open(PatientFileViewComponent, {
      panelClass: 'dialog-form',
      width: '2000px',
      data: file,
    })
  }

  public downloadFile({ event, file }: { event: MouseEvent, file: PatientUploadedFile }) {
    event.stopPropagation()
    event.preventDefault()
    window.open(file.signedUrl, '_blank')
  }

  public deleteSelectedFiles() {
    this.delete.emit(this.selection.selected)
    this.selection.clear()
  }

  public deleteFile(file: PatientUploadedFile) {
    this.delete.emit([file])
  }

}
